export default __webpack_public_path__ + "static/media/boya_logo_white.dea29fae.svg";